import React, { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "@mui/material";
import { useStyles } from "../../data/DataStyles";
import loadingViewSvg from "../../../assets/images/loading.svg";

export const BodyLoadingModal = (loading: boolean): JSX.Element => {
  const classes = useStyles();
  const [t] = useTranslation("global");

  return (
    <div className="loading-views-div">
      <Fade in={loading}>
        <div className={classes.paperModal}>
          <h2 className="title-export">{`${t(
            "Common_options.Loading",
          )}${"..."}`}</h2>
          <img src={loadingViewSvg} alt="loadingViewSvg" />
        </div>
      </Fade>
    </div>
  );
};
